import * as React from 'react';
import { Field } from 'redux-form';
import { PortalInputField } from 'components/FormControls/PortalInputField';
import { PortalSelectMenu } from 'components/FormControls';
import { IDomainValue, ICountryCallingCodeDomainValue } from 'models/common';
import { required, maxLength } from 'helpers/validationattributes';

interface IProps {
	t?: (key: string) => string;
	countryDomainValues: IDomainValue[];
	countryCallingCodeDomainValues: ICountryCallingCodeDomainValue[];
	keyPrefix: string;
	shortPhoneNumberField?: boolean;
}

const maxLength25 = maxLength(25);
const maxLength50 = maxLength(50);
const maxLength255 = maxLength(255);

function OrderAddressForm(props: IProps): JSX.Element {
	const {
		t,
		countryDomainValues,
		countryCallingCodeDomainValues,
		keyPrefix,
		shortPhoneNumberField: simplePhone,
	} = props;

	let prefix = keyPrefix;
	if (prefix.length && prefix[prefix.length - 1] !== '.') {
		prefix = prefix + '.';
	}

	const countries = [];
	if (countryDomainValues) {
		countryDomainValues.forEach((country: IDomainValue) => {
			countries.push({
				key: country.key,
				value: t(`DV_Countries_${country.key}`),
			});
		});

		countries.sort(function (a: IDomainValue, b: IDomainValue) {
			if (a.value < b.value) {
				return -1;
			}
			if (a.value > b.value) {
				return 1;
			}
			return 0;
		});
	}

	let countryCallingCodes = [];
	if (countryCallingCodeDomainValues) {
		countryCallingCodes = countryCallingCodeDomainValues.map((countryCallingCode: ICountryCallingCodeDomainValue) => {
			return {
				key: countryCallingCode.key,
				value: t(`DV_CountryCallingCodes_${countryCallingCode.key}`),
			};
		});
	}

	return (
		<>
			<div className="row">
				<div className="col-md-12">
					<Field
						name={prefix + 'shippingName'}
						component={PortalInputField}
						type="text"
						label={t('Cart_CheckoutAddress_Label_NameAndSurname')}
						validate={[maxLength50, required]}
					/>
				</div>
			</div>

			<div className="row">
				<div className="col-md-12">
					<Field
						name={prefix + 'shippingAddressLine'}
						component={PortalInputField}
						type="text"
						label={t('Cart_CheckoutAddress_Label_StreetAndNumber')}
						validate={[maxLength255, required]}
					/>
				</div>
			</div>

			<div className="row">
				<div className="col-md-4">
					<Field
						name={prefix + 'shippingZIPCode'}
						component={PortalInputField}
						type="text"
						label={t('Cart_CheckoutAddress_Label_PostCode')}
						validate={[maxLength25, required]}
					/>
				</div>
				<div className="col-md-4">
					<Field
						name={prefix + 'shippingCity'}
						component={PortalInputField}
						type="text"
						label={t('Cart_CheckoutAddress_Label_City')}
						validate={[maxLength255, required]}
					/>
				</div>
				<div className="col-md-4">
					<Field
						name={prefix + 'shippingCountryKey'}
						component={PortalSelectMenu}
						items={countries}
						isRequired={true}
						validate={[required]}
						label={t('Cart_CheckoutAddress_Label_Country')}
					/>
				</div>
			</div>

			<div className="row">
				<div className="col-md-6">
					<Field
						name={prefix + 'email'}
						component={PortalInputField}
						type="text"
						label={t('Cart_CheckoutAddress_Label_Email')}
						validate={[maxLength255, required]}
					/>
				</div>
				{simplePhone ? (
					<div className="col-md-6">
						<Field
							name={prefix + 'shippingPhoneNumber'}
							component={PortalInputField}
							type="text"
							label={t('Cart_CheckoutAddress_Label_PhoneNumber')}
							validate={[maxLength50, required]}
						/>
					</div>
				) : undefined}
			</div>

			{simplePhone ? undefined : (
				<div className="row">
					<div className="col-md-3">
						<Field
							name={prefix + 'shippingCallingCodeKey'}
							component={PortalSelectMenu}
							items={countryCallingCodes}
							isRequired={true}
							label={t('Cart_CheckoutAddress_Label_PhoneNumber')}
						/>
					</div>
					<div className="col-md-9">
						<Field
							name={prefix + 'shippingPhoneNumber'}
							component={PortalInputField}
							type="text"
							validate={[maxLength50, required]}
						/>
					</div>
				</div>
			)}

			<div className="row">
				<div className="col-md-12">
					<Field
						name={prefix + 'shippingNote'}
						component={PortalInputField}
						type="text"
						label={t('Cart_CheckoutAddress_Label_Note')}
						validate={[maxLength255]}
					/>
				</div>
			</div>
		</>
	);
}

export { OrderAddressForm };
